import React, { useEffect, useState } from "react";
import { Box, TextField } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";
import { floatOnly } from "../../../../utils";

export default function WebEnumerateTxtInImg({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [inputValue, setInputValue] = useState("");
    
    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setInputValue("");
    }, [question]);

    const handleChange = (e) => {
        if (floatOnly(e.target.value) || e.target.value === "") {
            const value = e.target.value
            setInputValue(value);

            const canProceed = value !== "";
            onAnswer({
                canProceed,
                answer: value.toString(),
            });
        }
    };

    return (
        <Box
            sx={{
                maxWidth: 1100,
                margin: "0 auto",
                padding: "20px",
                backgroundColor: "white",
                textAlign: "center",
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    margin: "0 auto",
                }}
            >
                <Box
                    component="img"
                    src={`${imagesResources}${data.image}`}
                    alt="Question visual"
                    style={{
                        height: "auto",
                        display: "block",
                    }}
                />

                <Box
                    sx={{
                        position: "absolute",
                        top: "17%",
                        right: "6%",
                        width: "18%",
                        backgroundColor: "white",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <TextField
                        variant="standard"
                        type="text"
                        value={inputValue}
                        onChange={handleChange}
                        InputProps={{
                            startAdornment: "$",
                            autoComplete: 'off',
                            style: {
                                fontSize: "1.6em",
                            }
                        }}
                        sx={{
                            width: "100%",
                            backgroundColor: "white",
                            textAlign: "center",
                            input: {
                                padding: "4px",
                            },
                            "& .MuiInput-underline:after": {
                                borderBottom:
                                    "2px solid #00b0f0",
                            },
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};
